import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精选好剧
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            编辑精选，品质保证 —— 每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardsData.slice(0, 7).map((card, index) => (
            <div
              key={index}
              className="group bg-background-100 rounded-lg overflow-hidden hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-background-50/90 text-foreground-800 text-xs font-medium rounded whitespace-nowrap">
                  {card.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}